const animation = {
  "ani_01_title": "<span>ผสานวิทยาศาสตร์</span><span>และศิลปะ</span>",
  "ani_01_content": "ออกแบบด้วยวิทยาศาสตร์และศิลปะของงานฝีมือ ให้เข้ากับดวงตาของคุณ รังสรรค์ความงามของคุณด้วย Define®",

  "ani_02_title": "<span><em>เทคโนโลยี </em></span><span>Lacreon® </span><span>ศาสตร์แห่งศิลป์</span>",
  "ani_02_content": "ช่วยกักเก็บความชุ่มชื้นไว้ในเนื้อเลนส์",

  "ani_03_title": "<span>ขอบเลนส์บางด้วย</span> <span><em>Invisible</em></span> <span>Edge Design</span>",
  "ani_03_content": "ขอบเลนส์บาง โค้งรับเข้ากับรูปตา",

  "ani_04_title": "<span><em>ดีไซน์ตามหลัก </em></span><span><em> </em></span><span>วิทยาศาสตร์</span>",
  "ani_04_content": "เพลิดเพลินไปกับคอนแทคเลนส์แอคคิววิว ดีไฟน์ วิธ ลาครีออน",
}

export default animation
